module.exports = "https://coinrabbit.io/_next/static/images/zero-balance-ce85a334235eca1c763ce7f293ea53b1.svg";